@if (control?.touched && control?.invalid) {
  <small class="p-error text-[#e30000] dark:text-[#fe3939] mt-1">
    @if (control?.errors?.['required']) {
      Este campo es obligatorio.
    }
    @if (control?.errors?.['minlength']) {
      Debe tener al menos {{ control?.errors?.['minlength'].requiredLength }} caracteres.
    }
    @if (control?.errors?.['maxlength']) {
      No puede superar {{ control?.errors?.['maxlength'].requiredLength }} caracteres.
    }
    @if (control?.errors?.['pattern']) {
      El formato ingresado no es válido.
    }
    @if (control?.errors?.['max']) {
      El valor no puede superar {{ control?.errors?.['max'].max }}.
    }
  </small>
}